import { forwardRef } from 'react';

export const FullyDevelopedIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 97" ref={ref} {...props}>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M2 95.2h100M60.3 2v81.8l-48.1-.2V2.2L60.3 2zM26.2 54.5v-5.3m7 5.3v-5.3m7 5.3v-5.3m7 5.3v-5.3m-21 15.3v-5.3m7 5.3v-5.3m14 5.3v-5.3m7 5.3v-5.3m-28 15.3v-5.3m7 5.3v-5.3m7 5.3v-5.3m7 5.3v-5.3m7 5.3v-5.3m-28-54.7V9.2m7 5.3V9.2m7 5.3V9.2m7 5.3V9.2m0 25.3v-5.3m7-14.7V9.2m-21 35.3v-5.3m7 5.3v-5.3m14 5.3v-5.3m-21-14.7v-5.3m7 5.3v-5.3m14 5.3v-5.3m-28 15.3v-5.3m-7 25.3v-5.3m0 15.3v-5.3m0 15.3v-5.3m0-54.7V9.2m0 25.3v-5.3m0 15.3v-5.3m0-14.7v-5.3m21 15.3v-5.3m25-17l25.1-.2v71.8l-25.1-.2m5-29.1v-5.3m7 5.3v-5.3m0 15.3v-5.3m7 5.3v-5.3m-14 15.3v-5.3m7 5.3v-5.3m7 5.3v-5.3m-7-34.7v-5.3m-7 15.3v-5.3m14 5.3v-5.3m-14-14.7v-5.3m14 5.3v-5.3m-14 15.3v-5.3"
        />
      </svg>
    );
  },
);
